/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WorkOrderBoardCardDto } from './WorkOrderBoardCardDto';
import {
    WorkOrderBoardCardDtoFromJSON,
    WorkOrderBoardCardDtoFromJSONTyped,
    WorkOrderBoardCardDtoToJSON,
    WorkOrderBoardCardDtoToJSONTyped,
} from './WorkOrderBoardCardDto';

/**
 * 
 * @export
 * @interface WorkOrderBoardResponseDto
 */
export interface WorkOrderBoardResponseDto {
    /**
     * 
     * @type {Array<WorkOrderBoardCardDto>}
     * @memberof WorkOrderBoardResponseDto
     */
    workOrders: Array<WorkOrderBoardCardDto>;
}

/**
 * Check if a given object implements the WorkOrderBoardResponseDto interface.
 */
export function instanceOfWorkOrderBoardResponseDto(value: object): value is WorkOrderBoardResponseDto {
    if (!('workOrders' in value) || value['workOrders'] === undefined) return false;
    return true;
}

export function WorkOrderBoardResponseDtoFromJSON(json: any): WorkOrderBoardResponseDto {
    return WorkOrderBoardResponseDtoFromJSONTyped(json, false);
}

export function WorkOrderBoardResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkOrderBoardResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'workOrders': ((json['workOrders'] as Array<any>).map(WorkOrderBoardCardDtoFromJSON)),
    };
}

export function WorkOrderBoardResponseDtoToJSON(json: any): WorkOrderBoardResponseDto {
    return WorkOrderBoardResponseDtoToJSONTyped(json, false);
}

export function WorkOrderBoardResponseDtoToJSONTyped(value?: WorkOrderBoardResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'workOrders': ((value['workOrders'] as Array<any>).map(WorkOrderBoardCardDtoToJSON)),
    };
}

